import React, { Fragment, memo, useState } from "react";
import GenericPaginator from "./GenericPaginator";
import { useTranslation } from "react-i18next";


//import AdditionalInfo from "./AdditionalInfo";
//import ConfirmationDialog from "./ConfirmationDialog";


function ZQRow(props) {
  const {
    classes,
    item,
    editGridValues,
    editRowValidationData,
    onChangeValue,
    canEdit,
    canDelete,
    columns,
    onDelete,
    onSelEdit,
    prefix,
    rowIdName,
    additionalOptions,
    firstItemClick,
    itemkey
  } = props;

  const [open, setOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDeleteDialogLoading, setIsDeleteDialogLoading] = useState(false);

  const haveAdditionalInfo = columns.find((c) => c.dbname === 'additional_info');

  var printedClickeable = false;

  const closeDeleteDialog = () => {
    Promise.all([setIsDeleteDialogOpen(false),
    setIsDeleteDialogLoading(false)]);
  };

  const deleteItem = async () => {
    setIsDeleteDialogLoading(true);
    await onDelete(item.id);
    closeDeleteDialog();
  };

  const onDeleteItem = () => {
    setIsDeleteDialogOpen(true);
  };

  const printEditValue = (column) => {
    return (
      <td
        key={`${prefix}_f4_${item.id}_${column.id}`}
        align={column.align || "left"}
        style={{ minWidth: column.minWidth, maxHeight: 10 }}>
        {
          column.type === 'boolean' ?
            (
              column.alwayseditable ?
                <div classNAme="form-check form-switch mb-2" key={`tablecell_${prefix}_${column.dbname}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={item[column.dbname] === 1}
                    onChange={(event) => { (!!column.onChange && column.onChange(event, item)) || onChangeValue(event, item, column.dbname) }}
                  />
                </div>
                : <div className="form-check" key={`tablecell_${prefix}_${column.dbname}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    onChange={(event) => { onChangeValue(event, item, column.dbname) }}
                    checked={item[column.dbname] === 1}
                  />
                </div>
            ) :
            <input
              onChange={(event) => { onChangeValue(event, item, column.dbname, event.target.value) }}
              type={column.type === 'number' ? 'number' : 'text'}
              value={item[column.dbname] || ""}
            />

        }
      </td>
    )
  }

  const visibleRows = columns.reduce((prev, curr) => {
    if (curr.visible) return prev + 1;
    return prev;
  }, 0);


  const renderClickeable = (column) => {
    if (column.type === 'number') {
      if (item[column.dbname] !== undefined) {
        if (!printedClickeable && !!firstItemClick) {
          printedClickeable = true;
          return (<div className="clickeable" onClick={() => { firstItemClick(item['id']) }}>{new Intl.NumberFormat().format(item[column.dbname])}</div>);
        }
        return (<>{new Intl.NumberFormat().format(item[column.dbname])}</>);
      }
      return (<></>);
    }

    if (!printedClickeable && !!firstItemClick) {
      printedClickeable = true;
      return (<div className="clickeable" onClick={() => { firstItemClick(item['id']) }} title={item[column.dbname]}>{item[column.dbname]}</div>);
    }
    return (<div title={item[column.dbname]} >{item[column.dbname]}</div>)
  }

  return (
    <tr key={itemkey}>
      {
        columns.map((column) => {
          return (
            <>
              {
                column.visible && (!column.editable || !editGridValues) &&
                <td key={`${prefix}_f2_${item.id}__${column.id}`}
                  align={column.align || "left"}
                  style={{ minWidth: column.minWidth, padding: 5 }}
                  alt={item[column.dbname]}

                >
                  {
                    column.foreign ?
                      item[column.foreign.dbname] :
                      column.type === 'boolean' ?
                        (column.alwayseditable ? <div className="form-check form-switch mb-2">
                          <input className="form-check-input" type="checkbox" defaultChecked={item[column.dbname] === 1} onChange={(event) => { (column.onChange && column.onChange(event, item)) || onChangeValue(item, column.dbname) }} />
                        </div> :
                          (item[column.dbname] === undefined ? '' : item[column.dbname] ?
                            <i className="bx bx-check text-success"></i> :
                            <i className='bx bx-x text-danger'></i>)) :
                        column.type === 'datetime' ?
                          (
                            item[column.dbname] ?
                              new Date(item[column.dbname]).toLocaleString() :
                              ''
                          ) :
                          renderClickeable(column)
                  }
                </td>
              }
              {
                column.visible && column.editable && editGridValues &&
                (!editRowValidationData || item[editRowValidationData.field] === editRowValidationData.value) &&
                printEditValue(column)
              }
              {
                column.visible && column.editable && editGridValues &&
                (editRowValidationData && item[editRowValidationData.field] !== editRowValidationData.value) &&
                <td key={`${prefix}_f3_${item.id}__${column.id}`}></td>
              }
            </>
          )
        })
      }
      <td>
        <div className="dropdown">
          <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
            <i className="bx bx-dots-vertical-rounded"></i>
          </button>
          {
            (canEdit || canDelete) &&
            < div className="dropdown-menu">
              {
                canEdit && <span className="dropdown-item" onClick={() => { onSelEdit(item[rowIdName || "id"]) }} ><i className="bx bx-edit-alt me-1"></i> Edit</span>
              }
              {
                canDelete && <span className="dropdown-item" onClick={onDeleteItem}><i className="bx bx-trash me-1"></i> Delete</span>
              }
            </div>
          }
        </div>
      </td>


      {
        additionalOptions && <div>
          {additionalOptions.map((ao) => (<a className="dropdown-item" href="javascript:void(0);"><i className="bx bx-trash me-1"></i> Aditional info</a>))}
        </div>
      }

    </tr >
  )
}

function ZQTable(props) {
  const {
    classes,
    columns,
    data,
    selectable,
    gridEdit,
    alwayseditable,
    onChangeValue,
    canEdit,
    canDelete,
    editRowValidationData,
    onChangeRowsPerPage,
    //orderBy,
    onChangeOrder,
    onPageChange,
    onDelete,
    onSelEdit,
    paginationInfo,
    prefix,
    rowIdName,
    isLoading,
    firstItemClick,
    additionalOptions
  } = props;

  const [editGridValues, setEditGridValues] = useState(!!alwayseditable);

  const haveAdditionalInfo = columns.find((c) => c.dbname === 'additional_info');

  const { t } = useTranslation();

  const handleChangeRowsPerPage = (rowsPerPage) => {
    onChangeRowsPerPage(rowsPerPage.target.value);
  };

  const handleChangePage = (event, page) => {
    onPageChange(page);
  };

  const handleChangeOrder = (headerDbName) => {
    onChangeOrder(headerDbName);
  };

  const editValuesGrid = () => {
    setEditGridValues(!editGridValues);
  };

  return (
    <div className="table-responsive text-nowrap min-size-table personal-table">
      {
        paginationInfo.count > paginationInfo.rowsPerPage &&
        <GenericPaginator
          rowsPerPageOptions={[5, 10, 20]}
          count={paginationInfo.count}
          rowsPerPage={paginationInfo.rowsPerPage}
          page={paginationInfo.page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton={true}
          showLastButton={true}
        />
      }


      {/*         {isLoading &&
          <Spinner />
        } */}
      {/* {gridEdit && !alwayseditable && <AppRegistrationOutlined onClick={editValuesGrid} />} */}
      <table className="table table-hover ">
        <thead>
          <tr>
            {haveAdditionalInfo && haveAdditionalInfo.visible && <th className={classes.theader}></th>}
            {
              columns.map((column) => {
                if (column.visible)
                  return (
                    <th key={`${prefix}_f1_${column.id}`}>
                      <div
                        onClick={() => { onChangeOrder && handleChangeOrder(column.dbname) }}
                        key={`${prefix}_column.id`}
                        align={column.align}
                        className=""
                        style={{ minWidth: column.minWidth }}>
                        {t(column.label)}
                      </div>
                    </th>
                  )
              })
            }
            <th className=""></th>
          </tr>
        </thead>
        <tbody className="table-border-bottom-0">
          {
            data &&
            data.map((item, idx) => (
              <ZQRow
                classes={classes}
                itemkey={`${prefix}_zqr_${item.id}_${idx}`}
                item={item}
                columns={columns}
                editRowValidationData={editRowValidationData}
                selectable={selectable}
                editGridValues={editGridValues}
                canEdit={canEdit}
                canDelete={canDelete}
                onDelete={onDelete}
                onSelEdit={onSelEdit}
                prefix={prefix}
                onChangeValue={onChangeValue}
                rowIdName={rowIdName}
                additionalOptions={additionalOptions}
                firstItemClick={firstItemClick}
              />
            ))
          }
        </tbody>
      </table>
      {
        paginationInfo.count > paginationInfo.rowsPerPage &&
        <GenericPaginator
          rowsPerPageOptions={[5, 10, 20]}
          count={paginationInfo.count}
          rowsPerPage={paginationInfo.rowsPerPage}
          page={paginationInfo.page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton={true}
          showLastButton={true}
        />
      }
    </div>
  );
}

export default ZQTable;